import { REQUIRED } from './validationErrorMessages';
export const isNonEmpty = (value) => {
  if (typeof value === 'number') {
    return value ? null : REQUIRED;
  }
  return value && value.length ? null : REQUIRED;
};
